import './mask-field-ref.scss'

import { PropType } from "vue"
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import _ from 'lodash';

import { EntityField, EntityFieldStatus } from '@skinsoft/types';
import { TranslationDataStore } from '@skinsoft/entity';

import { ReactiveVue } from '@skinsoft/reactive-vue';
import { EntitySelect } from '@skinsoft/ui';
import { first } from 'rxjs/operators';

@Component({
    components: {
        sEntitySelect: EntitySelect,
    },
    props: {
        entityField: {
            type: Object as PropType<EntityField>,
        },
        fieldValue: {},
        editing: {
            type: Boolean,
        },
        getStatus: {},
        dataCy: {
            type: String,
        },
    },
    template: require('./mask-field-ref.html')
})
export class MaskFieldRef extends ReactiveVue {
    private entityField: EntityField
    private fieldValue: any
    private editing: Boolean
    private dataCy: String
    private getStatus: (entityField: EntityField) => EntityFieldStatus

    private fieldLabel: string = ""
    private entitySelectKey: string = "" // used for reactivity issue with EntitySelect

    private $translationDataStore: TranslationDataStore

    mounted() {
        this.updateKey()   
    }

    private get value(): String {
        return _.get(this.fieldValue, 'ref') ?? this.fieldValue ?? ''
    }

    private onEntitySelected(entity: any) {
        this.$emit("value-change", {
            abstractEntity: this.entityField.abstractEntity,
            fieldPath: this.entityField.path,
            value: entity.id,
        })
    }

    private thesaurusIdentifierIfNeeded(entityField: EntityField) {
        if (entityField.type.type === "ThesaurusTerm") {
            return entityField.type.thesaurusIdentifier
        }

        if (entityField.type.entityFieldType?.type === "ThesaurusTerm") {
            return entityField.type.entityFieldType.thesaurusIdentifier
        }

        return null
    }

    private fetchLabel(key: string) {
        let translationKey: string = `field.${key}`
        if (this.entityField.entityFields
            && this.entityField.entityFields.length > 0) {
            translationKey += ".complex"
        }
        this.subscribeTo(
            this.$translationDataStore.getMessage(translationKey, this.getAppLocale()).pipe(first()),
            translation => {
                this.fieldLabel = translation
            },
            'translation-subscription'
        )
    }

    private isReadonly(entityField: EntityField) {
        return entityField.isReadOnly || this.getStatus(entityField).disabled
    }

    private infoMessage(entityField: EntityField): string | undefined {
        return this.getStatus(entityField).disabledMessage
    }

    private errorMessage(entityField: EntityField): string | undefined {
        return this.getStatus(entityField).errorMessage
    }

    private hasError(entityField: EntityField) {
        return this.getStatus(entityField).error
    }

    // used for reactivity issue with EntitySelect
    private updateKey() {
        if(this.fieldValue instanceof String || typeof this.fieldValue === "string") {
            this.entitySelectKey = this.fieldValue as string
            return
        }

        this.entitySelectKey = JSON.stringify(this.fieldValue)
    }

    @Watch('entityField', { immediate: true, deep: false })
    private onEntityFieldChange() {
        this.unsubscribeFrom('translation-subscription')
        this.fetchLabel(this.entityField.path);
    }

    @Watch('fieldValue')
    private onFieldValueChanged() {
        this.updateKey()
    }
}